export default function PageShell({ eyebrow, title, children }) {
  return (
    <div className="route-page">
      <section className="route-hero">
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
      </section>
      {children}
    </div>
  );
}
